module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAAV0lEQVRIie2VyREAIAjExDopb/vELw/HE7zGFGAm6wMSkeBJdH19uQCA+V6PTVQCgIxMeE6Bpqdmb8Ho7s0CC6YFtcrzC77gCwLpm2x1cJiZsgIP7v+DBJb1J2gf74U6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_histogram_grey.png
// module id = 336
// module chunks = 1